<div class="user-exit-editmode-pop">
  <div class="cds-h2-demibold">{{ 'leaveDelegatePopup.content' | lang }}</div>
  <div class="btn-box">
    <cds-button [config]="disagreeButtonConfig" (click)="disagree()" [label]="'leaveDelegatePopup.cancel' | lang"></cds-button>
    <cds-button [config]="agreeButtonConfig" (click)="agree()" [label]="'leaveDelegatePopup.confirm' | lang"></cds-button>
  </div>
</div>
